<template>
  <div ref="target">
    <div class="animated-in-view">
      <slot :is-revealed="isRevealed" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
  threshold: {
    type: Number,
    default: 0.5,
  },
});

const target = ref(null);
const isRevealed = ref(false);
const observer = new IntersectionObserver(([entry]) => {
  if (entry.isIntersecting) {
    isRevealed.value = true;
  }
}, { threshold: props.threshold });

onMounted(() => {
  observer.observe(target.value);
});

onUnmounted(() => {
  observer.disconnect();
});
</script>
